import { render, staticRenderFns } from "./DialogReturnMessageErrors.vue?vue&type=template&id=f7c507ee&"
import script from "./DialogReturnMessageErrors.vue?vue&type=script&lang=js&"
export * from "./DialogReturnMessageErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports